import ChangeCurrency from 'components/common/change-currency';
import ChangeLanguage from 'components/common/change-language';
import { FiPhone } from 'react-icons/fi';
import { IoMailOpenOutline } from 'react-icons/io5';

const Header = () => {
    return (
        <header
            id="header"
            className="relative z-50 hidden md:flex md:px-[37px] lg:px-40 h-9 items-center justify-between bg-primary text-white text-xs"
        >
            <div className="flex">
                <p className="flex items-center gap-x-2 w-[180px]">
                    <FiPhone />
                    <a href="tel:+994553087001">994(55) 308-70-01</a>
                </p>
                <p className="flex items-center gap-x-2 w-[180px]">
                    <FiPhone />
                    <a href="tel:+994993087001">994(99) 308-70-01</a>
                </p>
                <p className="flex items-center justify-end gap-x-2 w-[100px]">
                    <IoMailOpenOutline className="w-4 h-4" />
                    <a href="mailto:info@darxx.az">info@darxx.az</a>
                </p>
            </div>
            <div className="flex items-center md:gap-x-8 ">
                <ChangeCurrency />
                <ChangeLanguage />
            </div>
        </header>
    );
};

export default Header;
